import { StyledFormGroup } from '@monorepo/shared/componentsV2/styled/form';
import React, { useMemo } from 'react';
import { DatasetResponse } from 'mapistry-shared';
import {
  StyledConditionLabel,
  StyledConditionProperty,
  StyledConditionsContainer,
  StyledEqualText,
} from './styled';
import { getTimeSeriesPropertyLabel } from './helpers';

const EFFECTIVE_PERIOD_LABEL = 'Effective Date Range';

interface EffectivePeriodConditionProps {
  className?: string;
  inputDataset: DatasetResponse;
}

export function EffectivePeriodCondition({
  className,
  inputDataset,
}: EffectivePeriodConditionProps) {
  const inputDatasetPropertyLabel = useMemo(() => {
    if (inputDataset.timeSeriesGranularity) {
      return getTimeSeriesPropertyLabel(inputDataset);
    }
    return EFFECTIVE_PERIOD_LABEL;
  }, [inputDataset]);
  return (
    <StyledConditionsContainer className={className}>
      <StyledFormGroup row>
        <div>
          <StyledConditionLabel>Field 1</StyledConditionLabel>
          <StyledConditionProperty
            content={inputDatasetPropertyLabel}
            isLocked
          />
        </div>
        <StyledEqualText>
          {inputDataset.timeSeriesGranularity ? 'within' : 'overlaps'}
        </StyledEqualText>
        <div>
          <StyledConditionLabel>Field 2</StyledConditionLabel>
          <StyledConditionProperty content={EFFECTIVE_PERIOD_LABEL} isLocked />
        </div>
      </StyledFormGroup>
    </StyledConditionsContainer>
  );
}
